export enum YandexWordFields {
    ya_name = "ya_name",
    ya_full_name = "ya_full_name",
    ya_inn = "ya_inn",
    ya_address = "ya_address",
    ya_address_eng = "ya_address_eng",
    ya_reg_num = "ya_reg_num",
    ya_system_name = "ya_system_name",
    ya_org_id = "ya_org_id",
    ya_eng_name_full = "ya_eng_name_full",
    ya_eng_name_short = "ya_eng_name_short",
    ya_reg_date = "ya_reg_date",
    ya_kpp = "ya_kpp",
    ya_kpp_main = "ya_kpp_main",
    ya_oktmo = "ya_oktmo",
    ya_okpo = "ya_okpo",
    ya_it_num = "ya_it_num",
    ya_it_start_date = "ya_it_start_date",
    ya_bank_name = "ya_bank_name",
    ya_bic = "ya_bic",
    ya_payment_account = "ya_payment_account",
    ya_corr_account = "ya_corr_account",
    ya_general_visa_login = "ya_general_visa_login",
    ya_general_visa_fio = "ya_general_visa_fio",
    ya_general_visa_familyio = "ya_general_visa_familyio",
    ya_general_visa_iofamily = "ya_general_visa_iofamily",
    ya_general_visa_gen = "ya_general_visa_gen",
    ya_general_visa_dat = "ya_general_visa_dat",
    ya_general_visa_acc = "ya_general_visa_acc",
    ya_general_visa_inst = "ya_general_visa_inst",
    ya_general_visa_prepos = "ya_general_visa_prepos",
    ya_general_visa_job = "ya_general_visa_job",
    ya_general_visa_job_gen = "ya_general_visa_job_gen",
    ya_general_visa_job_dat = "ya_general_visa_job_dat",
    ya_general_visa_job_acc = "ya_general_visa_job_acc",
    ya_general_visa_job_inst = "ya_general_visa_job_inst",
    ya_general_visa_job_prepos = "ya_general_visa_job_prepos",
    ya_general_visa_last_name = "ya_general_visa_last_name",
    ya_general_visa_first_name = "ya_general_visa_first_name",
    ya_general_visa_middle_names = "ya_general_visa_middle_names",
    ya_general_visa_birth_date = "ya_general_visa_birth_date",
    ya_general_visa_inn = "ya_general_visa_inn",
    ya_general_visa_snils = "ya_general_visa_snils",
    ya_general_visa_citizenship = "ya_general_visa_citizenship",
    ya_org_country = "ya_org_country",
    ya_org_region = "ya_org_region",
    ya_org_area = "ya_org_area",
    ya_org_town = "ya_org_town",
    ya_org_settlement = "ya_org_settlement",
    ya_org_street = "ya_org_street",
    ya_org_house = "ya_org_house",
    ya_org_building = "ya_org_building",
    ya_org_apartment = "ya_org_apartment",
    ya_org_postal_code = "ya_org_postal_code",
    ya_org_combination = "ya_org_combination",
}
